import gsap from 'gsap';
import Swiper from 'swiper/bundle';
import RelaxScroll from './libs/relaxScroll.js';
import 'swiper/css/bundle';
import { isMobile } from './libs/utility.js';

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * 初期化処理
	 * @function init
	 */
	const init = () => {
		new RelaxScroll();
		swiperInit();
		fadeInInit();
	};

	init();
});

/**
 * Swiperを初期化する関数
 * @function swiperInit
 * @returns {void}
 */
const swiperInit = () => {
	const mainimgSwiper = new Swiper('.swiper', {
		loop: true,
		effect: 'fade',
		autoplay: {
			delay: 4500,
		},
		speed: 1500,
	});
};

/**
 * fadeInを初期化する関数
 * @function fadeInInit
 * @returns {void}
 */
const fadeInInit = () => {
	const elements = gsap.utils.toArray('.fade-in');
	for (let i = 0; i < elements.length; i++) {
		gsap.from(elements[i], {
			opacity: 0,
			y: isMobile ? 50 : 80,
			duration: 1,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: elements[i],
				start: 'top 80%',
			},
		});
	}
};
